class ConfigDeveloper {
  cpf = '12867880726';
  psw = '';
  isDevelopment = process.env.VUE_APP_ENVIRONMENT === 'development';

  /**
   * Retorna as credenciais (CPF e senha) se o ambiente for de desenvolvimento.
   * @returns {{ cpf: string, password: string } | null} Um objeto contendo o CPF e a senha,
   * ou null se não for o ambiente de desenvolvimento.
   */
  getFormLogin () {
    if (!this.isDevelopment) {
      return null;
    }
    return {
      cpf: this.cpf,
      password: this.psw
    };
  }
}

export default ConfigDeveloper;